<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> {{ pageName }}
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse1" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="4">
                      <div class="form-group">
                        <label>Logo</label>
                        <div class="d-flex justify-content-center p-4">
                          <div class="profile-img-upload">
                            <img v-if="logoUrl" :src="logoUrl" alt="img">
                            <img v-else src="../../assets/img/image.jpg" alt="img">
                            <input type="file" class="profileImgUpload"
                                   id="profileImgUpload"
                                   @change="onLogoChoose"
                                   accept="image/*">
                            <label for="profileImgUpload">
                                            <span class="profile-img-upload-title">
                                                <i class="fa fa-camera mr-2"></i>
                                                <span>Change</span>
                                            </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </b-col>
                    <b-col sm="4">
                      <TextBox v-model="item.title" placeholder="Title"
                               :addClass="{'is-invalid': $v.item.title.$error}">Title</TextBox>
                      <TextBox v-model="item.totalCoin" placeholder="0" type="number"
                               :addClass="{'is-invalid': $v.item.totalCoin.$error}">Total Coin</TextBox>
                      <SelectBox :items="types" v-model="item.type"
                                 :addClass="{'is-invalid': $v.item.type.$error}">Type</SelectBox>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                        <b-col sm="8">
                          <DatePicker v-model="item.endDate"
                                      :addClass="{'is-invalid': $v.item.endDate.$error}">End Date</DatePicker>
                        </b-col>
                        <b-col sm="4">
                          <TextBox v-model="time" type="time">End Time</TextBox>
                        </b-col>
                      </b-row>
                      <SelectBox :items="statuses" v-model="item.status">Special Offer category</SelectBox>
                      <Textarea v-model="item.description" rows="5" placeholder="Description"
                                :addClass="{'is-invalid': $v.item.description.$error}">Description</Textarea>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <transition name="fade">
                        <b-card no-body>
                          <div slot="header">
                            <i class="fa fa-edit"></i> Promo codes
                            <div class="card-header-actions">
                              <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                                <i class="icon-arrow-up"></i>
                              </b-link>
                            </div>
                          </div>
                          <b-collapse id="collapse1" visible>
                            <b-card-body>
                              <b-row>
                                <b-col sm="6">
                                  <table class="table table-bordered table-sm">
                                    <thead class="thead-light">
                                    <tr>
                                      <th width="70%" scope="col">Promo</th>
                                      <th width="30%" scope="col">Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(promo, index) in promoCodes" :key="index">
                                      <td>
                                        <b-form-input v-model="promo.code"></b-form-input>
                                      </td>
                                      <td style="text-align: center;vertical-align: middle;">
                                        <span>{{ promo.status }}</span>
                                      </td>
                                      <td class="text-center">
                                        <b-button variant="danger" size="sm" @click="removeAnswer(promo)"><i class="icon-close"></i></b-button>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="3" class="text-center">
                                        <b-button variant="success" size="sm" @click="addNewRow"><i class="icon-plus"></i> New Item</b-button>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </b-col>
                              </b-row>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                      </transition>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-end">
                    <div class="form-actions">
                      <b-button right type="submit" variant="primary" @click="onSubmit">Save</b-button>
                      <router-link type="cancel" class="btn btn-secondary" variant="secondary" :to="'/exchange-service'">Cancel</router-link>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, integer } from 'vuelidate/lib/validators'

export default {
  name: 'ExchangeServiceAddEditPage',
  data () {
    return {
      item: {
        type: 'SINGLE'
      },
      time: null,
      channels: [],
      logoUrl: '',
      promoCodes: [],
      types: [
        {text: 'One Time', value: 'SINGLE'},
        {text: 'Many Times', value: 'MULTIPLE'}
      ],
      statuses: [
        {text: '', value: null},
        {text: 'New', value: 'NEW'}
      ]
    }
  },
  created () {
    if (!this.$route.params.id || this.$route.params.id <= 0) {
      this.item.type = 'SINGLE'
      return
    }
    this.$loading.show()
    this.axios.get('exchange-service/item', {params: {id: this.$route.params.id}})
      .then(response => {
        this.item = response.data.data
        if (this.item.promoCodes) {
          this.promoCodes = this.item.promoCodes
        }
        if (this.item && this.item.endDate) {
          this.time = this.getTimeFormat(this.item.endDate)
          this.item.endDate = new Date(this.item.endDate)
        }
        if (this.item.image) {
          this.logoUrl = this.item.image.url
        }
        this.$loading.hide()
      })
      .catch(error => {
        this.$loading.hide()
        if (error.response && error.response.data.status === 400) {
          this.$toastr.error(error.response.data.message)
        }
      })
  },
  computed: {
    pageName () {
      return this.$route.params.id ? 'Edit Shop Item' : 'Add Shop Item'
    }
  },
  methods: {
    onSubmit () {
      if (this.$v.item.$invalid) {
        this.$v.$touch()
        return
      }
      const codes = []
      if (this.promoCodes) {
        this.promoCodes.forEach(function (item) {
          if (item.code) {
            console.log('item ')
            codes.push({
              code: item.code,
              status: item.status
            })
          }
        })
      }
      console.log('codes ' + codes.length)
      if (codes.length < 1) {
        this.$toastr.error('Promo code is required')
        this.$v.$touch()
        return
      }
      this.item.promoCodes = codes
      if (this.time) {
        this.item.endDate.setHours(this.time.split(':')[0], this.time.split(':')[1])
      }
      this.$loading.show()
      let axios
      if (this.item.id) {
        axios = this.axios.put('exchange-service/item', this.item)
      } else {
        axios = this.axios.post('exchange-service/item', this.item)
      }
      axios.then((res) => {
        this.$loading.hide()
        if (res.data && res.data.status === 200) {
          this.$toastr.success(res.data.message)
          this.$router.push('/exchange-service')
        } else {
          this.$toastr.error(res.data.message)
        }
      })
    },
    removeAnswer (item) {
      const itemIndex = this.promoCodes.indexOf(item)
      if (itemIndex !== -1) {
        this.promoCodes.splice(itemIndex, 1)
      }
    },
    addNewRow () {
      this.promoCodes.push({
        status: 'NEW'
      })
    },
    getTimeFormat (dateString) {
      const date = new Date(dateString)
      let hour = '0'
      if (date.getHours() < 10) {
        hour += date.getHours()
      } else {
        hour = date.getHours()
      }
      let minute = '0'
      if (date.getMinutes() < 10) {
        minute += date.getMinutes()
      } else {
        minute = date.getMinutes()
      }
      return hour + ':' + minute
    },
    onLogoChoose (event) {
      this.selectedFile = event.target.files[0]
      const formData = new FormData()
      formData.append('uploadFile', this.selectedFile)

      this.$loading.show()
      this.axios.post('upload',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
        .then((response) => {
          if (response.data) {
            this.item.image = response.data
            this.logoUrl = response.data.url
          }
          this.$loading.hide()
        })
        .catch(error => {
          this.$loading.hide()
          if (error.response && error.response.data.status === 400) {
            this.$toastr.error(error.response.data.message)
          }
        })
    }
  },
  validations: {
    item: {
      title: {
        required
      },
      type: {
        required
      },
      totalCoin: {
        integer,
        required
      },
      description: {
        required
      },
      endDate: {
        required
      }
    }
  }
}
</script>

<style scoped>
.profile-img-upload {
  width: 12.57143rem;
  height: 12.57143rem;
  background: gray;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
}

.profile-img-upload input[type="file"] {
  display: none;
}

.profile-img-upload label {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  background: rgba(0, 0, 0, 0.5);
  line-height: 12.57143rem;
  transition: opacity 0.3s;
  text-align: center;
  cursor: pointer;
}

.profile-img-upload label:hover {
  opacity: 1;
}

.profile-img-upload-title {
  color: white;
  font-size: 1.42857rem;
}

.profile-img-upload-title i {
  font-size: 1.85714rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/exchangeService/ExchangeServiceAddEditPage.vue